import { useAuth } from "../auth/useAuth";
import { strings } from "../strings";

export function SignInScreen() {
  const { login } = useAuth();

  return (
    <div className="eg-sign-in">
      <h1>{strings.appName}</h1>
      <button type="button" onClick={login}>
        {strings.auth.signIn}
      </button>
    </div>
  );
}
